import React from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import WithTemplates from "data/wrappers/WithTemplates"
import AttributesForm from "features/records/components/AttributesForm"


const UseTemplateButton = props => (
    <React.Fragment>
        <WithTemplates>
            {({ templates, clone }) => (
                <ButtonModal
                    button={({ open }) => (
                        <Button color="success" onClick={open}>
                            Use Template
                        </Button>
                    )}
                    header={() => `New ` + props.templateName}
                    footerClassName={css`
                    justify-content: flex-end;
                `}
                    footer={({ close, state }) => [
                        <Button
                            key="create"
                            sideMargin="xsmall"
                            color="success"
                            onClick={() => {
                                clone(templates.filter(template => (
                                    template.base_url === props.templateURL
                                )).shift()._sid, state.name, () => {
                                    close();
                                })
                                window.location = "/";
                            }}
                        >
                            Create
                    </Button>,
                        <Button key="cancel" sideMargin="xsmall" onClick={close}>
                            Cancel
                    </Button>,
                    ]}
                >
                    {({ setState }) => (
                        <React.Fragment>
                            <AttributesForm
                                onChange={setState}
                                fields={[
                                    { type: "text", label: "Name", api_name: "name" }
                                ]}
                            />
                        </React.Fragment>
                    )}

                </ButtonModal>
            )}
        </WithTemplates >
    </React.Fragment >
)
export default UseTemplateButton



// WEBPACK FOOTER //
// ./src/features/studio/components/UseTemplateButton.js